import Vue from 'vue'
import Router from 'vue-router'
import HelloWorld from '@/components/HelloWorld'
import Hw from '@/components/Hw'
Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'HelloWorld',
      component: HelloWorld
    },
    {
      path: '/bugs',
      name: 'Hw',
      component: Hw
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js